import React, { Component } from 'react';
import PropTypes from 'prop-types';
import View from '@scene/views/object-view';

import './styles.scss';
import { EventManager, EVENTS } from '@components/Events/events';
import tabs from './../../App/tabs';
import Spinner from '@components/LoadingStyles/Spinner';
import { APP_STATES, APP_TYPES } from '@config';

export default class ObjectViews extends Component {

  static propTypes = {
    init: PropTypes.func.isRequired,
    nextMode: PropTypes.string.isRequired,
    setMode: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  static defaultProps = {
    className: '',
  };

  constructor(props) {
    super(props);

    this.state = {
      currentTab: null
    };

    this.onTabChanged = this.onTabChanged.bind(this);
  }

  onTabChanged(tab) {
    this.setState({
      currentTab: tab
    });
  }

  componentWillUnmount() {
    EventManager.removeListener(EVENTS.TAB_SWITCHED, this.onTabChanged);
  }

  componentDidMount() {
    this.props.init();
    EventManager.addListener(EVENTS.TAB_SWITCHED, this.onTabChanged);
  }

  render() {
    return (
      <div className={`container ${this.props.className}`}>
        {this.props.isGettingSnapshots && (<Spinner extraClass="report-spinner" />)}
        <section id="object-view-container" className="container__view">
          <button
            className="container__mode-btn btn btn-dark m-2"
            onClick={() => {
              this.props.setMode(this.props.currentMode, this.props.nextMode);
            }}>
            {'>' + this.props.nextMode}
          </button>
        
          {this.props.appType !== APP_TYPES.SAFETY_BARRIER || this.props.currentMode === View.mode.MODE_2D ? (
            <button className="container__reset-btn btn btn-dark m-2" onClick={() => {
              this.props.resetCamera();
            }}>
              {/*eslint-disable*/}
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path d="M506.555 208.064L263.859 30.367c-4.68-3.426-11.038-3.426-15.716 0L5.445 208.064c-5.928 4.341-7.216 12.665-2.875 18.593s12.666 7.214 18.593 2.875L256 57.588l234.837 171.943c2.368 1.735 5.12 2.57 7.848 2.57 4.096 0 8.138-1.885 10.744-5.445 4.342-5.927 3.054-14.251-2.874-18.592z" />
                <path d="M442.246 232.543c-7.346 0-13.303 5.956-13.303 13.303v211.749H322.521V342.009c0-36.68-29.842-66.52-66.52-66.52s-66.52 29.842-66.52 66.52v115.587H83.058V245.847c0-7.347-5.957-13.303-13.303-13.303s-13.303 5.956-13.303 13.303V470.9c0 7.347 5.957 13.303 13.303 13.303h133.029c6.996 0 12.721-5.405 13.251-12.267.032-.311.052-.651.052-1.036V342.01c0-22.009 17.905-39.914 39.914-39.914s39.914 17.906 39.914 39.914V470.9c0 .383.02.717.052 1.024.524 6.867 6.251 12.279 13.251 12.279h133.029c7.347 0 13.303-5.956 13.303-13.303V245.847c-.001-7.348-5.957-13.304-13.304-13.304z" />
              </svg>
              {/*eslint-enable*/}
            </button>
          ) : (
            <button className="container__zoom-in-out-btn btn btn-dark m-2"
              onClick={() => {
                this.props.setPerspectiveCameraType(this.props.perspectiveCameraType);
              }}>
              <span className="icon_zoom_in_out" />
            </button>
          )}

          {this.props.appStatus !== APP_STATES.NOT_INITIALIZED &&
            this.props.appStatus !== APP_STATES.REVIEW_OPTIONS &&
            this.props.currentMode === View.mode.MODE_3D && (
              <React.Fragment>
                <button className="container__show-dim-btn btn btn-dark m-2"
                  onClick={() => {
                    if (this.props.displayDimensions)
                      this.props.hide3DDimensions();
                    else
                      this.props.show3DDimensions();
                  }}>
                  <span className={`${this.props.displayDimensions ? "icon_hide_3d_dimensions" : "icon_show_3d_dimensions"}`} />
                </button>
                <button className="container__show-labels-btn btn btn-dark m-2"
                  onClick={() => {
                    this.props.setDimensionsLabels(!this.props.displayLabels);
                  }}>
                  <span className={`${this.props.displayLabels ? "icon_hide_3d_labels" : "icon_show_3d_labels"}`} />
                </button>
              </React.Fragment>
            )}

          {this.props.nextMode === View.mode.MODE_2D && this.state.currentTab === tabs.LOADS && (
            <div className="container__units">
              [{this.props.loadUnit}&nbsp;/&nbsp;{this.props.momentUnit && this.props.momentUnit.replace(' ', "\u00A0")}]
            </div>
          )}
        </section>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/ObjectViews/ObjectViews.js